import { Box, HStack, VStack, Button } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BasicLoadingSpinner from "components/BasicLoadingSpinner";
import SupportTickets from "components/customer/Support/SupportTickets";
import { FC, Suspense, useState } from "react";
import useZendeskSSO from "hooks/useZendeskSSO";
import { ZENDESK_BASE_URL } from "util/config";
import { faCheckToSlot, faPlus } from "@fortawesome/free-solid-svg-icons";
import useCustomerUnreadTickets from "hooks/useCustomerUnreadTickets";
import useMarkTicketAsRead from "hooks/useMarkTicketAsRead";
import { ZendeskAPI } from "react-zendesk";
import NotificationsDropdown from "components/NotificationsDropdown";

const SupportTicketsPage: FC = () => {
    const makeZendeskLink = useZendeskSSO();
    const { data: unread } = useCustomerUnreadTickets();
    const { markAllAsRead } = useMarkTicketAsRead();

    // If the user is clicking the button over and over then either:
    //  - The chat widget isn't open
    //  - The chat widget is open but the user doesn't realize or doesn't want to use it
    // In either case, open the Zendesk New Ticket link in a new tab
    const [rageClickCount, setRageClickCount] = useState(0);
    const handleClick = () => {
        if (rageClickCount === 2) {
            openZendeskLink();
            setRageClickCount(0);
        }
        setRageClickCount((old) => old + 1);

        ZendeskAPI("webWidget", "open");
    };

    const openZendeskLink = async () => {
        const zendeskLink = await makeZendeskLink(
            `${ZENDESK_BASE_URL}/hc/en-us/requests`,
        );
        window.open(zendeskLink, "_blank");
    };

    return (
        <Box
            p={25}
            w="100%"
            minHeight="75vh"
            maxW={{ base: "100%", lg: "80rem" }}
            color="var(--dcs-black)"
        >
            <HStack justify="space-between">
                <VStack alignItems="start" spacing={1}>
                    <HStack alignItems="center" spacing={2}>
                        <Box fontSize={36} textAlign="center" color="white">
                            Support Messages
                        </Box>
                        <Button
                            bgColor="var(--dcs-blue)"
                            onClick={openZendeskLink}
                            fontSize={16}
                            fontWeight="semibold"
                            color="white"
                            lineHeight="1em"
                            padding={2}
                            size="sm"
                        >
                            <ExternalLinkIcon />
                        </Button>
                    </HStack>
                    {unread && unread.ticketIds.length > 0 && (
                        <Button size="sm" onClick={markAllAsRead}>
                            <HStack spacing={2}>
                                <span>Mark all as Read</span>
                                <FontAwesomeIcon icon={faCheckToSlot} />
                            </HStack>
                        </Button>
                    )}
                </VStack>
                <HStack>
                    <Box
                        bgColor="black"
                        rounded="full"
                        padding="3"
                        cursor="pointer"
                        _hover={{
                            outline: "2px solid var(--dcs-blue)",
                        }}
                        as="button"
                        onClick={handleClick}
                    >
                        <FontAwesomeIcon
                            icon={faPlus}
                            color="white"
                            size="xl"
                        />
                    </Box>
                    <NotificationsDropdown />
                </HStack>
            </HStack>
            <Suspense fallback={<BasicLoadingSpinner />}>
                <Box
                    overflow="scroll"
                    maxHeight="62vh"
                    maxW="100%"
                    marginTop={4}
                >
                    <SupportTickets />
                </Box>
            </Suspense>
        </Box>
    );
};

export default SupportTicketsPage;
